// How a player likes the game shown, kept in this browser (localStorage): set on the profile page, read by the game.
// Other tabs open in the same browser follow a change at once.
import { useEffect, useState } from 'react';

// Static buttons: the action bar under the player's board (a button for each kind of action, its target picked where
// it is) in place of the action panel's buttons for those actions. Off unless chosen.
const StaticButtonsKey = 'tta-static-buttons';

// The new UI: the culture and military boards under the card row, for everyone (TableBoards.js, MilitaryBoard.js), in
// place of the military area on each board and the Nobel Prize and Olympic Games boxes beside the actions. Off unless
// chosen, while it is tried out.
const NewUIKey = 'tta-new-ui';

const read = (key) => {
    try { return window.localStorage.getItem(key) === 'on'; } catch { return false; }
};

// A setting kept under key: [whether it is on, a function to turn it on or off]
const usePreference = (key) => {
    const [on, setOn] = useState(() => read(key));
    useEffect(() => {
        const changed = (event) => event.key === key && setOn(read(key));
        window.addEventListener('storage', changed);
        return () => window.removeEventListener('storage', changed);
    }, [key]);
    const set = (value) => {
        try { window.localStorage.setItem(key, value ? 'on' : 'off'); } catch { /* (then only for this page) */ }
        setOn(value);
    };
    return [on, set];
};

export const useStaticButtons = () => usePreference(StaticButtonsKey);

export const useNewUI = () => usePreference(NewUIKey);
